import React from "react";

const DataCard = ({ title, value, icon, color = "blue", subtitle, loading }) => {
  return (
    <div
      className={`bg-white rounded-lg shadow-md border border-${color}-200 p-6 hover:shadow-lg transition-shadow`}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm text-gray-600 mb-1">{title}</p>
          {loading ? (
            <div className="h-8 w-24 bg-gray-200 animate-pulse rounded"></div>
          ) : (
            <h3 className={`text-2xl font-bold text-${color}-700`}>{value}</h3>
          )}
          {subtitle && (
            <p className="text-xs text-gray-500 mt-1">{subtitle}</p>
          )}
        </div>
        {icon && (
          <div
            className={`w-12 h-12 bg-${color}-100 rounded-full flex items-center justify-center`}
          >
            <i className={`${icon} text-${color}-600 text-xl`}></i>
          </div>
        )}
      </div>
    </div>
  );
};

export default DataCard;
